import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import { Megaphone, Phone } from "lucide-react";

const KLEUR = { actief: "bg-emerald-100 text-emerald-800", wacht_op_bel: "bg-rose-100 text-rose-800", voltooid: "bg-neutral-800 text-white", uitgestroomd: "bg-stone-200 text-stone-700", overgeslagen: "bg-amber-100 text-amber-800" };

export function OrgCampagnesBlok({ orgId }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/organisaties/${orgId}/campagnes`).then(r => setData(r.data)).catch(() => setData({ deelnames: [], beltaken: [] })); }, [orgId]);
  if (!data || (!data.deelnames.length && !data.beltaken.length)) return null;
  return (
    <div className="bg-card border border-border rounded-xl p-4 space-y-3" data-testid="org-campagnes-blok">
      <h3 className="text-sm font-semibold flex items-center gap-2"><Megaphone className="h-4 w-4 text-primary" />Campagnes</h3>
      <div className="space-y-2">{data.deelnames.map(d => (
        <div key={d.id} className="text-xs flex items-start gap-2" data-testid="org-deelname">
          <Badge className={`border-0 h-5 ${KLEUR[d.status] || ""}`}>{d.status}</Badge>
          <div className="min-w-0"><Link to={`/campagnes/${d.campagne_id}`} className="font-medium hover:text-primary">{d.campagne_naam}</Link>
            <div className="text-muted-foreground">{d.huidige_stap_naam ? `stap: ${d.huidige_stap_naam}` : d.uitstroom_reden || ""} · sinds {fmtDateTime(d.ingeschreven_op)}</div></div>
        </div>))}</div>
      {data.beltaken.length > 0 && <div className="space-y-1 pt-1 border-t border-border">{data.beltaken.slice(0, 5).map(b => (
        <div key={b.id} className="text-xs flex items-center gap-2" data-testid="org-beltaak"><Phone className="h-3 w-3 text-muted-foreground" /><span className="truncate flex-1">{b.reden}</span><Badge variant="outline" className="h-4 text-[10px]">{b.status === "afgerond" ? b.uitkomst : b.status}</Badge></div>))}</div>}
    </div>
  );
}
